import React, { useRef, useEffect } from 'react'
import MessageBubble from './messageBubble'

const ChatMessages = ({ messages }) => {
  const chatWindowRef = useRef(null)

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight
    }
  }, [messages])

  return (
    <div
      ref={chatWindowRef}
      style={{
        flex: 1,
        overflowY: 'auto',
        background: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        scrollbarWidth: 'thin',
        scrollbarColor: '#d1d5db #f3f4f6'
      }}
    >
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        width: '100%',
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        minHeight: '100%'
      }}>
        {messages.map((message) => (
          <MessageBubble
            key={message.id}
            role={message.role}
            text={message.text}
            typing={message.typing}
            thinking={message.thinking}
            inThinking={message.inThinking}
            thinkingDone={message.thinkingDone}
          />
        ))}
      </div>
    </div>
  )
}

export default ChatMessages